<div
  [class]="'pt-view-request-details__history-item pt-view-request-details__history-item_' + status">
  <dt>{{ item().createdAt | date:'dd MMM y' }}</dt>

  <dd>{{ 'dictionary.financialRequestHistoryType.' + item().eventType | translate }}: {{value}}</dd>
</div>
